export enum Status {
    InActive = 0,
    Active = 1
}

export enum WorkRestEventType {
    Work = 1,
    Rest = 4
}

export enum TwoUpEventType {
    TwoUpStart = 0,
    TwoUpStop = 1
}

export enum TwoUpWorkRestOption {
    Standard = 0,
    BFM = 2,
    AFM = 3,
    Exemption = 4
}

export enum WorkRestOption {
    Standard = 0,
    StandardBus = 1,
    BFM = 2,
    AFM = 3,
    Exemption = 4
}

export enum EventRecordStatus {
    Unknown = 0,
    Active = 1,
    InactiveChanged = 2,
    InactiveChangeRequested = 3,
    InactiveChangeRejected = 4
}

export enum LoginActivity {
    Login = 1,
    Logout = 2
}

export enum RowState {
    Unchanged = 0,
    Added = 1,
    Updated = 2,
    Deleted = 3
}

export enum State {
    ACT = 0,
    NSW = 1,
    NT = 2,
    QLD = 3,
    SA = 4,
    TAS = 5,
    VIC = 6,
    WA = 7
}

export enum LicenceState {
    ACT = 0,
    NSW = 1,
    NT = 2,
    QLD = 3,
    SA = 4,
    TAS = 5,
    VIC = 6,
    WA = 7,
    OTH = 8
}


export enum EWDOrigin {
    None = 0,
    EWD = 1,
    Historic = 2,
    External = 3
}

export enum TransferStatus {
    Error = 0,
    Requested = 1,
    Queued = 2,
    SentToServer = 3,
    Initiated = 4,
    DataGenerated = 5,
    FileGenerated = 6,
    FileSaved = 7,
    EmailInitiated = 8,
    EmailSent = 9
}

export enum ProviderType {
    "None" = <any>0,
    "Written Work Diary" = <any>1,
    "Internal" = <any>2,
    "External" = <any>3
}
